import React, { Fragment, useEffect, useState, useRef } from "react";
import { getEventosPorDeporteParis } from "services/getEventosCalendario";
import Card from "components/envivo/card/card.js";
import Loading from "components/loading/loading";
import SinResultados from "components/calendarios/calendarioGangwon/sinResultados/sinResultados";
import "./listadoDiaDeporte.sass";


export default function ListadoDiaDeporte({ seccion, deporte }) {
    const [dataEventos, setDataEventos] = useState([]);
    const [error, setError] = useState(false);
    const [showLoading, setShowLoading] = useState(true);

    // peticion al servicio para obtener los eventos del calendario
    useEffect(() => {
        if (deporte) {
            getEventosPorDeporteParis(String(deporte).toUpperCase(), seccion)
                .then((eventos) => {
                    if (eventos && eventos.data && eventos.statusCode === 200) {
                        let transmissions = eventos.data
                            .sort((a, b) =>
                                new Date(a.session_start_time_utc) - new Date(b.session_start_time_utc) ||
                                new Date(a.session_end_time_utc) - new Date(b.session_end_time_utc)
                            );

                        setDataEventos(transmissions);
                    } else if (eventos && eventos.statusCode === 404 && eventos.statusCode !== undefined) {
                        setError(true);
                        setDataEventos([]);
                    }
                })
                .finally(() => {
                    setShowLoading(false);
                    setError(false);
                });
        }
    }, [deporte, seccion])


    //------- INICIAR EJECUCION DE REZISE DEL COMPONENTE -------
    const envivoRef = useRef(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const newHeight = entry.contentRect.height;

                window.requestAnimationFrame(() => {
                    const message = {
                        sentinel: "amp",
                        type: "embed-size",
                        height: newHeight,
                    };
                    window.parent.postMessage(message, "*");
                });
            });
        });

        if (envivoRef.current) {
            resizeObserver.observe(envivoRef.current);
        }

        // Limpia el ResizeObserver al desmontar el componente
        return () => {
            resizeObserver.disconnect();
        };
    }, [envivoRef]);
    //------- TERMINA EJECUCION DE REZISE DEL COMPONENTE -------


    return (
        <div ref={envivoRef}>
            {/* seccion loading */}
            {showLoading && (<Loading />)}

            {/* seccion sin resultados  */}
            {(!showLoading && !error && dataEventos && dataEventos.length === 0 ) && <SinResultados componenteActual={seccion} />}

            {/* seccion con resultados de busqueda del dia */}
            {!showLoading && dataEventos && dataEventos.length !== 0 && <div className="envivo-component-listado-general">

                <div className="container-general-envivo-listado-general">

                    {dataEventos && dataEventos.length !== 0 && dataEventos.map((item) =>
                        <Fragment key={item._id}>
                            <Card imagen={item.image} disciplina={item.discipline} disciplina_id={item.discipline_id} titulo={String(item.session_title).length === 0 ? item.session_title_editorial : item.session_title} horaInicio={item.session_start_time_utc} horaFin={item.session_end_time_utc} enlace={item.url} tipo="icono" porDeporte={true} estaEnvivo={item?.is_live}/>
                        </Fragment>
                    )}
                </div>
            </div>
            }
        </div>
    )
}